// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.riga-testa {
  display: flex;
  flex-wrap: wrap;
  gap: 6px 10px;
  align-items: baseline;
  margin: 6px 0;
}
.riga-testa > b {
  font-size: 17px;
  font-weight: 800;
  letter-spacing: 0.01em;
  color: var(--ion-text-color);
}

.riga-ruolo {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  padding: 2px 8px;
  border-radius: 999px;
  background: #eef2ff;
  color: #1e3a8a;
}

.riga-desc {
  font-size: 13px;
  opacity: 0.85;
}

.riga-altra {
  opacity: 0.7;
}

.freccia-riga, .fine-riga, .separatore-altre {
  font-size: 13px;
  font-weight: 500;
  color: var(--ion-color-medium);
  margin: 6px 0;
}

.freccia-riga {
  color: var(--ion-color-primary);
}

.separatore-altre {
  border-top: 1px solid var(--ion-color-medium);
  padding-top: 8px;
}

.da-fare {
  background: #ffffff;
  border: 2px solid #d1d5db;
  color: #374151;
}

.passata {
  background: #e8f5ec;
  border: 2px solid #2e7d4f;
  color: #1b4d32;
}

.attuale {
  background: #1d5fd6;
  border: 2px solid #0f3d91;
  color: #ffffff;
  box-shadow: 0 0 0 4px rgba(29, 95, 214, 0.25);
}

.prossima {
  background: #fff4e5;
  border: 2px dashed #c2410c;
  color: #7c2d12;
}

.alternativa, .fuori {
  background: #f3f4f6;
  border: 2px dotted #9ca3af;
  color: #4b5563;
}

.riga {
  border: 1px solid var(--ion-color-light-shade, #d1d5db);
  border-radius: 12px;
  padding: 10px 12px;
  margin: 8px 0;
}
@media (min-width: 768px) {
  .riga {
    display: grid;
    grid-template-columns: minmax(180px, 220px) minmax(0, 1fr);
    gap: 12px;
    align-items: center;
  }
}
.riga .riga-testa {
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  margin: 0;
}
@media (min-width: 768px) {
  .riga .riga-testa {
    border-right: 1px solid var(--ion-color-light-shade, #d1d5db);
    padding-right: 12px;
  }
}
.riga .fine-riga {
  grid-column: 1/-1;
}

.riga-contenitore {
  border: 2px solid #1d5fd6;
}

.freccia-riga {
  text-align: right;
}

.corsia {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
}

.nota-altra {
  margin-left: auto;
  color: var(--ion-color-medium);
}

.tessera {
  min-width: 140px;
  min-height: 64px;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding: 6px 12px;
  text-align: left;
}
.tessera .tessera-titolo {
  font-size: 15px;
  font-weight: 800;
}
.tessera small {
  font-size: 12px;
}
.tessera.selezionata {
  outline: 3px solid var(--ion-text-color, #111827);
  outline-offset: 2px;
}

.freccia {
  color: var(--ion-color-medium);
  font-size: 20px;
  font-weight: 700;
}`, "",{"version":3,"sources":["webpack://./src/app/_components/contenitori/contenitore-percorso/_percorso-riga.scss","webpack://./src/app/_components/contenitori/contenitore-percorso-mappa/contenitore-percorso-mappa.component.scss","webpack://./src/app/_components/contenitori/contenitore-percorso/_percorso-posizioni.scss"],"names":[],"mappings":"AAEE;EACE,aAAA;EACA,eAAA;EACA,aAAA;EACA,qBAAA;EACA,aAAA;ACDJ;ADII;EACE,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,4BAAA;ACFN;;ADME;EACE,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;ACHJ;;ADME;EACE,eAAA;EACA,aAAA;ACHJ;;ADME;EACE,YAAA;ACHJ;;ADME;EACE,eAAA;EACA,gBAAA;EACA,8BAAA;EACA,aAAA;ACHJ;;ADME;EACE,+BAAA;ACHJ;;ADME;EACE,6CAAA;EACA,gBAAA;ACHJ;;AC9CE;EACE,mBAAA;EACA,yBAAA;EACA,cAAA;ADiDJ;;AC9CE;EACE,mBAAA;EACA,yBAAA;EACA,cAAA;ADiDJ;;AC9CE;EACE,mBAAA;EACA,yBAAA;EACA,cAAA;EACA,6CAAA;ADiDJ;;AC9CE;EACE,mBAAA;EACA,0BAAA;EACA,cAAA;ADiDJ;;AC9CE;EACE,mBAAA;EACA,0BAAA;EACA,cAAA;ADiDJ;;AAxEA;EACE,uDAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;AA2EF;AAzEE;EANF;IAOI,aAAA;IACA,0DAAA;IACA,SAAA;IACA,mBAAA;EA4EF;AACF;AA1EE;EACE,sBAAA;EACA,uBAAA;EACA,QAAA;EACA,SAAA;AA4EJ;AA1EI;EANF;IAOI,6DAAA;IACA,mBAAA;EA6EJ;AACF;AA1EE;EACE,iBAAA;AA4EJ;;AAxEA;EACE,yBAAA;AA2EF;;AAxEA;EACE,iBAAA;AA2EF;;AAxEA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,QAAA;AA2EF;;AAxEA;EACE,iBAAA;EACA,8BAAA;AA2EF;;AAxEA;EACE,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;EACA,iBAAA;EACA,gBAAA;AA2EF;AAzEE;EACE,eAAA;EACA,gBAAA;AA2EJ;AAxEE;EACE,eAAA;AA0EJ;AAvEE;EACE,iDAAA;EACA,mBAAA;AAyEJ;;AArEA;EC/CE,8BAAA;EACA,eAAA;EACA,gBAAA;ADwHF","sourcesContent":["// Feature 166: intestazione di riga e separatori comuni alle viste del percorso.\n@mixin riga {\n  .riga-testa {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 6px 10px;\n    align-items: baseline;\n    margin: 6px 0;\n\n    // Codice articolo della riga: il dato che l'operatore cerca per primo.\n    > b {\n      font-size: 17px;\n      font-weight: 800;\n      letter-spacing: .01em;\n      color: var(--ion-text-color);\n    }\n  }\n\n  .riga-ruolo {\n    font-size: 11px;\n    font-weight: 700;\n    letter-spacing: .04em;\n    text-transform: uppercase;\n    padding: 2px 8px;\n    border-radius: 999px;\n    background: #eef2ff;\n    color: #1e3a8a;\n  }\n\n  .riga-desc {\n    font-size: 13px;\n    opacity: .85;\n  }\n\n  .riga-altra {\n    opacity: .7;\n  }\n\n  .freccia-riga, .fine-riga, .separatore-altre {\n    font-size: 13px;\n    font-weight: 500;\n    color: var(--ion-color-medium);\n    margin: 6px 0;\n  }\n\n  .freccia-riga {\n    color: var(--ion-color-primary);\n  }\n\n  .separatore-altre {\n    border-top: 1px solid var(--ion-color-medium);\n    padding-top: 8px;\n  }\n}\n","@use '../contenitore-percorso/percorso-riga' as r;\n@use '../contenitore-percorso/percorso-posizioni' as p;\n\n@include r.riga;\n@include p.posizioni;\n\n// Mockup C: ogni riga è un riquadro; dai 768 px intestazione a sinistra e fasi a destra.\n.riga {\n  border: 1px solid var(--ion-color-light-shade, #d1d5db);\n  border-radius: 12px;\n  padding: 10px 12px;\n  margin: 8px 0;\n\n  @media (min-width: 768px) {\n    display: grid;\n    grid-template-columns: minmax(180px, 220px) minmax(0, 1fr);\n    gap: 12px;\n    align-items: center;\n  }\n\n  .riga-testa {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 2px;\n    margin: 0;\n\n    @media (min-width: 768px) {\n      border-right: 1px solid var(--ion-color-light-shade, #d1d5db);\n      padding-right: 12px;\n    }\n  }\n\n  .fine-riga {\n    grid-column: 1 / -1;\n  }\n}\n\n.riga-contenitore {\n  border: 2px solid #1d5fd6;\n}\n\n.freccia-riga {\n  text-align: right;\n}\n\n.corsia {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 6px;\n}\n\n.nota-altra {\n  margin-left: auto;\n  color: var(--ion-color-medium);\n}\n\n.tessera {\n  min-width: 140px;\n  min-height: 64px;\n  border-radius: 10px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n  padding: 6px 12px;\n  text-align: left;\n\n  .tessera-titolo {\n    font-size: 15px;\n    font-weight: 800;\n  }\n\n  small {\n    font-size: 12px;\n  }\n\n  &.selezionata {\n    outline: 3px solid var(--ion-text-color, #111827);\n    outline-offset: 2px;\n  }\n}\n\n.freccia {\n  @include p.freccia;\n}\n","// Feature 166: colori di posizione condivisi dalle viste del percorso (contrasto >= 4.5:1, mockup).\n@mixin posizioni {\n  .da-fare {\n    background: #ffffff;\n    border: 2px solid #d1d5db;\n    color: #374151;\n  }\n\n  .passata {\n    background: #e8f5ec;\n    border: 2px solid #2e7d4f;\n    color: #1b4d32;\n  }\n\n  .attuale {\n    background: #1d5fd6;\n    border: 2px solid #0f3d91;\n    color: #ffffff;\n    box-shadow: 0 0 0 4px rgba(29, 95, 214, .25);\n  }\n\n  .prossima {\n    background: #fff4e5;\n    border: 2px dashed #c2410c;\n    color: #7c2d12;\n  }\n\n  .alternativa, .fuori {\n    background: #f3f4f6;\n    border: 2px dotted #9ca3af;\n    color: #4b5563;\n  }\n}\n\n// Fuori dalle card: colori del tema, leggibili anche in modalità scura.\n@mixin freccia {\n  color: var(--ion-color-medium);\n  font-size: 20px;\n  font-weight: 700;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
